module.exports = __webpack_public_path__ + "img/word_ball_mask.126722bd.svg";